<template>
  <el-row :gutter="20">
    <el-col :span="8">
      <FormItem :label="$t('analysesStatusManagement.edit.productCode')">
        <el-input
          v-model="formData.productCode"
          @change="update"
        />
      </FormItem>
    </el-col>
    <el-col :span="8">
      <FormItem :label="$t('analysesStatusManagement.edit.productName')">
        <el-input
          v-model="formData.productName"
          @change="update"
        />
      </FormItem>
    </el-col>
    <el-col :span="8">
      <FormItem
        :label="$t('analysesStatusManagement.edit.customerProductName')"
      >
        <el-input
          v-model="formData.customerProductName"
          @change="update"
        />
      </FormItem>
    </el-col>
    <el-col :span="6">
      <FormItem :label="$t('analysesStatusManagement.edit.lot')">
        <el-input
          v-model="formData.lot"
          @change="update"
        />
      </FormItem>
    </el-col>
    <el-col :span="6">
      <FormItem :label="$t('analysesStatusManagement.edit.date')">
        <el-date-picker
          v-model="formData.date"
          type="date"
          @change="update"
        />
      </FormItem>
    </el-col>
    <el-col :span="6">
      <FormItem :label="$t('analysesStatusManagement.edit.sector')">
        <el-select
          v-model="formData.sector"
          placeholder="Select"
          @change="update"
        >
          <el-option
            v-for="item in sectors"
            :key="item.value"
            :label="$t(item.label)"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </FormItem>
    </el-col>
    <el-col :span="6">
      <FormItem :label="$t('analysesStatusManagement.edit.packagesNumber')">
        <el-input-number
          v-model="formData.packagesNumber"
          :controls="false"
          @change="update"
        />
      </FormItem>
    </el-col>
    <el-col :span="8">
      <FormItem :label="$t('analysesStatusManagement.edit.sampleDescription')">
        <el-select
          v-model="formData.sampleDescription"
          filterable
          placeholder="Select"
          @change="update"
        >
          <el-option
            v-for="item in sampleDescriptions"
            :key="item.value"
            :label="$t(item.label)"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </FormItem>
    </el-col>
    <el-col :span="8">
      <FormItem :label="$t('analysesStatusManagement.edit.costCenter')">
        <el-input
          v-model="formData.costCenter"
          :maxlength="100"
          @change="update"
        />
      </FormItem>
    </el-col>
    <el-col :span="8">
      <FormItem :label="$t('analysesStatusManagement.edit.finalCustomer')">
        <el-autocomplete
          v-model="bufferFinalCustomer"
          style="width: 100%"
          :fetch-suggestions="finalCustomerList"
          value-key="label"
          placeholder=""
          @change="updateCustomer"
          @select="handleSelectCustomer"
        />
      </FormItem>
    </el-col>
    <el-col :span="24">
      <AddressForm
        :configObject="{
          finalCustomer: formData.finalCustomer,
          addressId: formData.addressId,
          customerId: formData.customerId,
          countryPatch: formData.addressCountryPatch,
        }"
        @update="addressUpdated"
      />
    </el-col>
    <el-col :span="24">
      <FormItem :label="$t('analysesStatusManagement.edit.clientNotes')">
        <el-input
          v-model="formData.notes"
          @change="update"
          type="textarea"
        />
      </FormItem>
    </el-col>
    <el-col :span="24">
      <FormItem :label="$t('analysesStatusManagement.edit.comments')">
        <el-input
          v-model="formData.comments"
          @change="update"
          type="textarea"
        />
      </FormItem>
    </el-col>
    <!-- <el-col :span="24">
      <FormItem :label="$t('analysesStatusManagement.edit.analysisNotes')">
        <el-input
          v-model="formData.analysisNotes"
          @change="update"
          type="textarea"
        />
      </FormItem>
    </el-col> -->
    <el-col
      v-if="showSamplingInfo"
      :span="12"
    >
      <FormItem
        :label="$t('analysesData.changeSamplingInformation.samplingDate')"
      >
        <el-date-picker
          v-model="formData.samplingInfo.date"
          format="dd-MM-yyyy"
          value-format="yyyy-MM-dd"
          type="date"
          placeholder=""
          @change="updateSamplingDate"
        />
      </FormItem>
    </el-col>
    <el-col
      v-if="showSamplingInfo"
      :span="12"
    >
      <FormItem
        :label="$t('analysesData.changeSamplingInformation.samplingPlace')"
      >
        <el-input
          v-model="formData.samplingInfo.place"
          @change="update"
        ></el-input>
      </FormItem>
    </el-col>
    <el-col
      v-if="showSamplingInfo"
      :span="12"
    >
      <FormItem
        :label="$t('analysesData.changeSamplingInformation.samplingPlan')"
      >
        <el-input
          v-model="formData.samplingInfo.plan"
          @change="update"
        ></el-input>
      </FormItem>
    </el-col>
    <el-col
      v-if="showSamplingInfo"
      :span="12"
    >
      <FormItem
        :label="$t('analysesData.changeSamplingInformation.samplingMethod')"
      >
        <el-input
          v-model="formData.samplingInfo.method"
          @change="update"
        ></el-input>
      </FormItem>
    </el-col>
    <el-col
      v-if="showSamplingInfo"
      :span="24"
    >
      <FormItem
        :label="$t('analysesData.changeSamplingInformation.samplingBy')"
      >
        <el-select
          v-model="formData.samplingInfo.sampledBy"
          placeholder="Select"
          @change="update"
        >
          <el-option
            v-for="item in sampledBy"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </FormItem>
    </el-col>
    <el-col :span="24">
      <FormItem :label="$t('analysesStatusManagement.editLabNotes.notes')">
        <el-input
          v-model="formData.labNotes"
          @change="update"
          type="textarea"
        />
      </FormItem>
    </el-col>
  </el-row>
</template>

<script>
  import { customersApi } from '@/api';
  import {
    sectorsList,
    sampleDescriptionsList,
    SampledBy,
  } from '@/config/constants';
  import { enumOptions } from '@/config/enumOptions';

  import FormItem from '@/components/FormItem.vue';
  import AddressForm from './AddressForm.vue';

  const defaultData = {
    productCode: null,
    productName: null,
    customerProductName: null,
    lot: null,
    date: null,
    notes: null,
    finalCustomer: null,
    finalCustomerId: null,
    customerAddress: null,
    comments: null,
    addressId: null,
    samplingInfo: null,
    analysisNotes: null,
  };

  export default {
    name: 'EditSampleForm',
    components: {
      AddressForm,
      FormItem,
    },
    props: {
      initialData: { type: Object, default: () => defaultData, required: true },
      showSamplingInfo: { type: Boolean, default: false },
    },
    data() {
      return {
        formData: { ...this.initialData },
        bufferFinalCustomer: this.initialData.finalCustomer,
        addresses: [],
        loading: false,
        finalCustomers: {
          searched: false,
          data: [],
        },
      };
    },
    computed: {
      sampleDescriptions() {
        return enumOptions(
          sampleDescriptionsList,
          'enums.sampleDescriptions',
          this.formData.sampleDescription
        );
      },
      sectors() {
        return enumOptions(sectorsList, 'enums.sectors', this.formData.sector);
      },
      sampledBy() {
        return Object.values(SampledBy).map((val) => ({
          value: val,
          label: this.$t(`enums.sampledBy.${val}`),
        }));
      },
    },
    created() {
      if (!this.formData.samplingInfo) {
        this.formData.samplingInfo = {
          date: null,
          plan: null,
          place: null,
          method: null,
          sampledBy: SampledBy.Customer,
        };
      }
    },
    methods: {
      update() {
        this.$emit('update', { ...this.formData });
      },
      updateCustomer() {
        if (this.bufferFinalCustomer) {
          this.formData.finalCustomer = this.bufferFinalCustomer;
        } else {
          this.formData.finalCustomer = null;
        }
        this.update();
      },
      updateSamplingDate() {
        this.formData.samplingInfo.date = new Date(
          this.formData.samplingInfo.date
        ).toISOString();
        this.update();
      },
      addressUpdated(address, countryPatch) {
        if (address.id) {
          this.formData.addressId = address.id;
        } else {
          this.formData.addressId = null;
        }
        this.formData.customerHeaderData = address.customerHeaderData;
        this.formData.address = address;
        this.formData.addressCountryPatch = countryPatch;
        this.update();
      },
      async finalCustomerList(queryString, cb) {
        if (!this.finalCustomers.searched) {
          const results = await customersApi.getFinalCustomers(
            this.formData.customerId
          );
          const filteredResults = results.data
            .filter((f) => f !== null)
            .map((item) => ({
              label: item,
              value: item,
            }));
          this.finalCustomers.data = filteredResults;
          this.finalCustomers.searched = true;
        }
        cb(this.finalCustomers.data);
      },
      async handleSelectCustomer(item) {
        this.formData.finalCustomer = item.label;
        this.update();
      },
    },
  };
</script>
<style lang="scss" scoped>
  .el-input-number {
    width: 100%;
  }
</style>
